import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { size } from 'polished'

export const icon = (theme: Theme): SerializedStyles =>
  css({
    ...size(24),
    color: theme.palette.secondary.main,
    flexShrink: 0,
    marginRight: theme.spacing(0),
    path: {
      fill: theme.palette.secondary.main,
    },
  })

export const container = (theme: Theme): SerializedStyles =>
  css({
    alignItems: 'center',
    display: 'flex',
    padding: theme.spacing(1),
  })

export const content = css({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
})

export const label = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

export const place = (theme: Theme): SerializedStyles =>
  css({
    color: theme.palette.text.secondary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  })
